<template>
  <!--
    UMA missão do dia, do jeito que ela aparece em QUALQUER lugar: a tábua do Cais e o quadro de
    Missões Diárias usam esta mesma linha.

    Eram duas implementações — a tábua tinha trilho próprio, sem ícone, e o título herdava o
    `text-align: center` do `#app` enquanto a barra ficava à esquerda; o modal usava FishMeter e
    FishIcon. O jogador abria o quadro e via "outra coisa" com os mesmos dados (11/09/2026).
  -->
  <li class="linha-missao" :class="{ 'linha-missao--feita': missao.isComplete }">
    <FishIcon :nome="icone" tamanho="medio" />
    <div class="linha-missao__corpo">
      <p class="linha-missao__titulo">{{ titulo }}</p>
      <FishMeter
        :valor="missao.currentAmount || 0"
        :maximo="missao.amountRequired || 1"
        :cor="missao.isComplete ? 'bom' : 'agua'"
        tamanho="fino"
        :rotulo-acessivel="titulo"
      />
    </div>
    <span class="linha-missao__conta t-numero">{{ missao.currentAmount || 0 }}/{{ missao.amountRequired || 1 }}</span>
    <!-- O lugar do check existe sempre: sem ele, a barra da missão feita encolhia e saía da fila. -->
    <span class="linha-missao__feito">
      <FishIcon v-if="missao.isComplete" nome="check" tamanho="pequeno" />
    </span>
  </li>
</template>

<script>
import { FishIcon, FishMeter } from '@/shared/ui';
import { tituloDaMissao } from '@/shared/utils/tituloDaMissao';

/**
 * O selo de cada tipo. Tem que cobrir TODOS os tipos de `dailyMissions.tipos` — o que faltar cai no
 * `tasks` (a prancheta), que era o que `amountGold` e `amountExperience` mostravam. E o nome precisa
 * existir no `pixel-icons.css`, senão o FishIcon fica vazio sem erro.
 */
const ICONES = {
  amountCatchFish: 'fish',
  amountGold: 'coins',
  amountExperience: 'star',
  expensesGold: 'coins',
  expensesParallelium: 'gem',
  buyParallelium: 'gem',
  specificFish: 'crosshairs',
};

export default {
  name: 'LinhaDeMissao',
  components: { FishIcon, FishMeter },
  props: {
    missao: { type: Object, required: true },
  },
  computed: {
    titulo() {
      return tituloDaMissao(this.missao, this.$t.bind(this));
    },
    icone() {
      return ICONES[this.missao.type] || 'tasks';
    },
  },
};
</script>

<style scoped>
/* `text-align: left` explícito: o `#app` centraliza o jogo inteiro, e fora do Teleport do modal o
 * título saía centrado sobre uma barra alinhada à esquerda. */
.linha-missao {
  display: flex;
  align-items: center;
  gap: var(--e-2);
  text-align: left;
}

.linha-missao__corpo {
  flex: 1;
  min-width: 0;
}

.linha-missao__titulo {
  margin: 0 0 4px;
  font-family: var(--fonte-display);
  font-size: var(--f-2);
  color: var(--tinta);
}

/* A missão feita descansa: baixa a tinta, mantém o lugar. Nada some do quadro (D11). */
.linha-missao--feita .linha-missao__titulo {
  color: var(--tinta-fraca);
}

/* Largura FIXA, não mínima: com `min-width` a coluna crescia com o número ("0/10783" contra "0/1")
 * e cada barra terminava num lugar diferente. 8ch cabe "0/10783"; o que passar disso quebra a
 * linha em vez de desalinhar. */
.linha-missao__conta {
  flex: 0 0 8ch;
  font-size: var(--f-1);
  color: var(--tinta-fraca);
  text-align: right;
}

.linha-missao__feito {
  flex: 0 0 24px; /* o FishIcon `pequeno` */
  display: grid;
  place-items: center;
}
</style>
